import React, { useState } from "react";
import Modal from "../../../ReusableComponents/Modal";
import { CANCEL_ORDER_REASONS } from '../../../appConstants'
import Button from "../../../Components/RequestsOverView/Button";
export default function OrderCancelModal({
    open,
    onClose,
    onOrderCancel,
}) {
    const [cancelOrderReason, setcancelOrderReason] = useState(undefined);
    const [cancelOrderReasons, setcancelOrderReasons] = useState(CANCEL_ORDER_REASONS.map((note) => ({
        label: note,
        value: note
    })))

    const [otherReason, setOtherReason] = useState("");
    const [otherReasonError, setOtherReasonError] = useState("");

    const handleChange = (event) => {
        const value = event.target.value;
        setcancelOrderReason(value);
        if (value !== "Other") {
            setOtherReason("");
            setOtherReasonError("");
        }
    };

    const handleOtherReasonChange = (e) => {
        const value = e.target.value;
        setOtherReason(value);

        const valid = /^[A-Za-z\s]{20,}$/;
        if (!valid.test(value)) {
            setOtherReasonError("reason must be at least 20 characters and contain only letters and spaces.");
        } else if (value.length > 200) {
            setOtherReasonError("reason must be less than 200 characters");
        }
        else {
            setOtherReasonError("");
        }
    };

    const isSubmitDisabled =
        !cancelOrderReason ||
        (cancelOrderReason === "Other" && (otherReason.trim() === "" || otherReasonError));
    return (
        <Modal
            header={"Select reason to cancel order"}
            open={open}
            onClose={() => {
                setcancelOrderReason(undefined);
                setOtherReason("");
                setOtherReasonError("");
                onClose()
            }}
            contentStyle={{ width: "670px", height: "auto", boxShadow: " 0px 1.02px 4.09px 6.14px rgba(118, 118, 118, 0.15)" }}
            divider={true}
            headerContainerStyle={{ padding: "20px 25px" }}
            headingStyle={{ fontSize: "16px", fontWeight: 600 }}
            iconSize={"18px"}
        >
            <div className="flex flex-col justify-between">
                <div className="flex w-full justify-between py-4 px-8">
                    <div className="w-full px-4 ">
                        <h4 className="font-manrope font-[500] text-[16px] text-[#3B3B3B]">Select Resaon</h4>
                        <div className="flex flex-col gap-4 my-4">
                            {[...cancelOrderReasons, { label: "Other", value: "Other" }].map((option) => (
                                <div className="flex gap-3 text-[16px] font-manrope">
                                    <input
                                        className="cursor-pointer focus:outline-none "
                                        type="radio"
                                        name="options"
                                        height={8}
                                        width={10}
                                        value={option.value}
                                        checked={cancelOrderReason === option.value}
                                        onChange={handleChange}
                                    />
                                    <label key={option.value}>{option.label}</label>
                                </div>
                            ))}
                            {cancelOrderReason === "Other" && (
                                <div >
                                    <textarea
                                        style={{
                                            resize: "none",
                                        }}
                                        value={otherReason}
                                        rows={3}
                                        onChange={handleOtherReasonChange}
                                        className="w-full placeholder:text-[14px] font-manrope font-[500] border border-[#BFC8D9] text-[#1E1E1E] text-[15px] rounded px-3 py-2 focus:outline-none max-h-[80px] "
                                        placeholder="Enter your reason"
                                    />
                                    {otherReasonError && (
                                        <p className="text-[#ef233c]  font-manrope font-[600] text-[13px]">
                                            {otherReasonError}
                                        </p>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="flex ml-auto px-8 py-6 gap-6">
                    <Button
                        color={"#606571"}
                        variant={"outlined"}
                        title={"Cancel"}
                        width={"80px"}
                        handleClick={onClose}
                    />
                    <Button
                        color={"#0F5EFF"}
                        isDisbaled={isSubmitDisabled}
                        variant={"filled"}
                        title={"Ok"}
                        width={"80px"}
                        hoverColor={"#1251D2"}
                        handleClick={() => {
                            if (onOrderCancel) {
                                onOrderCancel(
                                    cancelOrderReason === "Other" ? otherReason.trim() : cancelOrderReason
                                )
                            }
                        }}
                    />
                </div>
            </div>
        </Modal>
    );
}
